import { Box, Text, Image, Heading, Button } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ShowBadgeLockedModal = ({ setShowBadgeLockedModal }: { setShowBadgeLockedModal: (v: boolean) => void }) => {
	const navigate = useNavigate();
	return (
		<Box textAlign={'center'}>
			<Image mx="auto" src="https://masai-website-images.s3.ap-south-1.amazonaws.com/Frame_1321317323_adfe5e88ce.svg" />
			<Heading color="#4358F6" as="h4" mt="16px">
				Badge Locked
			</Heading>
			<Box mt="10px" textAlign="center">
				<Text display={'inline'} textStyle={'body1-md'}>
					Reattempt this quiz after 7 days to get another chance to unlock your badge.
				</Text>
			</Box>
			<Button
				onClick={() => {
					// navigate('/dashboard');
					setShowBadgeLockedModal(false);
				}}
				bgColor={'#4358F6'}
				width={'100%'}
				variant={'primary'}
				mt="32px"
			>
				continue practising
			</Button>
		</Box>
	);
};

export default ShowBadgeLockedModal;
